import type { ButtonHTMLAttributes, ReactNode } from "react";
import { LoaderCircle } from "lucide-react";
import { button, type ButtonVariant } from "@web/theme/theme";

export type ButtonProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "className"> & {
  variant?: ButtonVariant;
  /** Full width (default on phone). */
  fullWidth?: boolean;
  loading?: boolean;
  icon?: ReactNode;
  /** Render as a link (tel:, mailto:, download) styled like the button. */
  href?: string;
  className?: string;
};

export function Button({ variant = "primary", fullWidth = true, loading = false, icon, href, className = "", children, disabled, type = "button", ...rest }: ButtonProps) {
  const classes = `${button.base} ${button.variant[variant]} ${fullWidth ? button.fullWidth : ""} ${className}`.trim();
  if (href) {
    return (
      <a href={href} aria-disabled={disabled || undefined} className={`${classes} ${disabled ? "pointer-events-none opacity-50" : ""}`.trim()} onClick={rest.onClick as unknown as React.MouseEventHandler<HTMLAnchorElement>}>
        {icon}
        {children}
      </a>
    );
  }
  return (
    <button
      type={type}
      aria-busy={loading || undefined}
      disabled={disabled || loading}
      className={classes}
      {...rest}
    >
      {loading ? <LoaderCircle aria-hidden size={20} className="animate-spin" /> : icon}
      {children}
    </button>
  );
}
